import {DEVICES_SERVICE_TYPE} from '../../common/constants/constants';
/**
 * @authors Halmai Feri && Huszta Laci
 */
export default {
	data() {
		return {
			visibles: []
		};
	},
	methods: {
		onClickDetails(index) {
			this.$set(this.visibles, index, !this.visibles[index]);
		},
		openOfferModal(params) {
			params.title = params.name;
			params.offerServiceType = DEVICES_SERVICE_TYPE; // az igényelt szolgáltatás típusa, amit az offer request-ben át kell adni.

			this.$store.dispatch('offerRequestStore/setModalParameters', {params});
			this.$store.dispatch('offerRequestStore/toggle');
		},
		isVisible(index) {
			let isVisible = !!this.visibles[index];

			return isVisible;
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/CD03-card-product/CD03-card-product.js